import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { LoadingOverlay } from '@/components/ui/Loader';
import { ROUTES } from '@/constants/routes';

export function ComingSoon({ title, description }: { title: string; description?: string }) {
  return (
    <div className="flex min-h-[320px] flex-col items-center justify-center rounded-2xl border border-dashed border-gray-200 bg-white p-10 text-center">
      <div className="mb-4 rounded-full bg-brand-surface px-4 py-1 text-xs font-semibold uppercase tracking-wide text-brand-muted">
        Coming soon
      </div>
      <h2 className="text-xl font-bold text-brand-navy">{title}</h2>
      {description && <p className="mt-2 max-w-md text-sm text-brand-muted">{description}</p>}
    </div>
  );
}

export function AuthShell({
  title,
  subtitle,
  children,
  footer,
  loading = false,
  loadingLabel = 'Please wait...',
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
  loading?: boolean;
  loadingLabel?: string;
}) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-hero-glow px-4 py-10">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <Link to={ROUTES.home} className="inline-flex items-center gap-3">
            <img src="/assets/logo-dark.jpeg" alt="AS DataLink" className="h-12 w-12 rounded-xl object-cover" width={48} height={48} />
            <span className="text-xl font-bold">
              <span className="text-primary">AS</span>
              <span className="text-secondary">DATALINK</span>
            </span>
          </Link>
          <h1 className="mt-6 text-2xl font-bold text-brand-navy">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-brand-muted">{subtitle}</p>}
        </div>
        <LoadingOverlay show={loading} label={loadingLabel} className="rounded-2xl">
          <div className="rounded-2xl border border-gray-100 bg-white p-6 shadow-card">{children}</div>
        </LoadingOverlay>
        {footer && <div className="mt-6 text-center text-sm text-brand-muted">{footer}</div>}
      </div>
    </div>
  );
}
